import { SubDomain } from "../../SubDomain";
import EmployeeData from "./EmployeeData.js";
import EmployeeDataMap from "./EmployeeDataMap.js";

export default class EmployeeDataDomain extends SubDomain {

  constructor(domain, storage) {
    super(domain, EmployeeData.MODEL_NAME);
    this._storage = storage;
  }

  list() {
    return this._storage ? this._storage.list : [];
  }

  findById(objId) {
    var object = this._storage ? this._storage.map[objId] : null;
    return new EmployeeData(this.domain, object);
  }

  findByAll() {
    var objects = this.list();
    var map = new EmployeeDataMap(this.domain);
    for (var i = 0; i < objects.length; i++) {
      map.add(new EmployeeData(this.domain, objects[i]));
    }
    return map;
  }
}
